
function displayEndorsementsList(endorseetype,endorseeid,target){
    httpGet(buildRoute(mantlroutes.endorsement_list,{ endorseetype: endorseetype, endorseeid: endorseeid })).then(
        function(value) {
            var response = JSON.parse(value);
            if(response.length > 0){
                var endorsements = {
                    type: endorseetype,
                    items: response
                }
                console.log(response,endorsements);
                var hbstemplate = mantlhbs.endorsements.list;
                var output = hbstemplate(endorsements);
                document.getElementById(target).innerHTML = output;
            }
        })
    .catch(
        function(reason) {
            alertify.error('Unable to Retrieve Issuer Endorsements')
        });
}
